import React from 'react';
import classnames from 'classnames';
import style from './tableHeading.scss';
import PropTypes from 'prop-types';

export const TableHeading = ({
  light = false,
  children,
  className = '',
  tagName = 'h6',
  ...rest
}) => {
  const getClassNames = () =>
    classnames({
      [style.tableHeading]: true,
      [style.light]: light,
    });
  const { dataHook, ...headingProps } = rest;

  return React.createElement(
    tagName,
    {
      ...headingProps,
      'data-hook': dataHook,
      className: `${getClassNames()} ${className}`,
    },
    children,
  );
};

TableHeading.propTypes = {
  children: PropTypes.any,
  light: PropTypes.bool,
};
